// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_managed.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Facets } from "../../search/v1/facet";
import { Any } from "../../../../google/protobuf/any";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBinding
 */
export interface AppManagedStateBinding {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3
     */
    resourceId: string;
    /**
     * @generated from protobuf field: string display_name = 4
     */
    displayName: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 5
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 6
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 7
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedState state = 8
     */
    state?: AppManagedState;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState
 */
export interface AppManagedState {
    /**
     * @generated from protobuf oneof: state
     */
    state: {
        oneofKind: "unmanaged";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged unmanaged = 100
         */
        unmanaged: AppManagedState_AppManagedStateUnmanaged;
    } | {
        oneofKind: "managed";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppManagedState.AppManagedStateManaged managed = 101
         */
        managed: AppManagedState_AppManagedStateManaged;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged
 */
export interface AppManagedState_AppManagedStateUnmanaged {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedState.AppManagedStateManaged
 */
export interface AppManagedState_AppManagedStateManaged {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingView
 */
export interface AppManagedStateBindingView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBinding app_management_state_binding = 1
     */
    appManagementStateBinding?: AppManagedStateBinding;
    /**
     * @generated from protobuf field: string app_path = 2
     */
    appPath: string;
    /**
     * @generated from protobuf field: string resource_path = 3
     */
    resourcePath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingExpandMask
 */
export interface AppManagedStateBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppManagedStateBindingRequest
 */
export interface GetAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 4
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppManagedStateBindingResponse
 */
export interface GetAppManagedStateBindingResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingView app_management_state = 1
     */
    appManagementState?: AppManagedStateBindingView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppManagedStateBindingsRequest
 */
export interface SearchAppManagedStateBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Query the apps with a fuzzy search on display name.
     *
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: repeated int32 states = 4
     */
    states: number[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5
     */
    expandMask?: AppManagedStateBindingExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingRef refs = 6
     */
    refs: AppManagedStateBindingRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 7
     */
    appIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppManagedStateBindingsRequest
 */
export interface ListAppManagedStateBindingsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 4
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * The ListAppManagedStateBindingsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppManagedStateBindingsResponse
 */
export interface ListAppManagedStateBindingsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingView list = 1
     */
    list: AppManagedStateBindingView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppManagedStateBindingsResponse
 */
export interface SearchAppManagedStateBindingsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingView list = 1
     */
    list: AppManagedStateBindingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingRef
 */
export interface AppManagedStateBindingRef {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3
     */
    resourceId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateBindingSearchFilter
 */
export interface AppManagedStateBindingSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppManagedStateBindingRef refs = 1
     */
    refs: AppManagedStateBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.PromoteAppManagedStateBindingRequest
 */
export interface PromoteAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3
     */
    resourceId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 4
     */
    userIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateSearchTermsRequest
 */
export interface AppManagedStateSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchAppManagedStateBindingsRequest search = 1
     */
    search?: SearchAppManagedStateBindingsRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType term = 2
     */
    term: AppManagedStateSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType
 */
export enum AppManagedStateSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_IDS = 1;
     */
    APP_IDS = 1
}
/**
 * @generated from protobuf message c1.api.app.v1.AppManagedStateSearchTermsResponse
 */
export interface AppManagedStateSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1
     */
    facets?: Facets;
}
/**
 * Currently unused
 *
 * @generated from protobuf message c1.api.app.v1.MutateAppManagedStateBindingRequest
 */
export interface MutateAppManagedStateBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string resource_type_id = 2
     */
    resourceTypeId: string;
    /**
     * @generated from protobuf field: string resource_id = 3
     */
    resourceId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedState state = 4
     */
    state?: AppManagedState;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5
     */
    expandMask?: AppManagedStateBindingExpandMask;
}
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBinding$Type extends MessageType<AppManagedStateBinding> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 8, name: "state", kind: "message", T: () => AppManagedState, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateBinding>): AppManagedStateBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateBinding): AppManagedStateBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 3:
                    message.resourceId = reader.string();
                    break;
                case /* string display_name */ 4:
                    message.displayName = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 5:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 6:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 7:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* c1.api.app.v1.AppManagedState state */ 8:
                    message.state = AppManagedState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 3; */
        if (message.resourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceId);
        /* string display_name = 4; */
        if (message.displayName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.displayName);
        /* google.protobuf.Timestamp created_at = 5; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 6; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 7; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedState state = 8; */
        if (message.state)
            AppManagedState.internalBinaryWrite(message.state, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBinding
 */
export const AppManagedStateBinding = new AppManagedStateBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState$Type extends MessageType<AppManagedState> {
    constructor() {
        super("c1.api.app.v1.AppManagedState", [
            { no: 100, name: "unmanaged", kind: "message", oneof: "state", T: () => AppManagedState_AppManagedStateUnmanaged },
            { no: 101, name: "managed", kind: "message", oneof: "state", T: () => AppManagedState_AppManagedStateManaged }
        ]);
    }
    create(value?: PartialMessage<AppManagedState>): AppManagedState {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.state = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<AppManagedState>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedState): AppManagedState {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged unmanaged */ 100:
                    message.state = {
                        oneofKind: "unmanaged",
                        unmanaged: AppManagedState_AppManagedStateUnmanaged.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).unmanaged)
                    };
                    break;
                case /* c1.api.app.v1.AppManagedState.AppManagedStateManaged managed */ 101:
                    message.state = {
                        oneofKind: "managed",
                        managed: AppManagedState_AppManagedStateManaged.internalBinaryRead(reader, reader.uint32(), options, (message.state as any).managed)
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedState, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged unmanaged = 100; */
        if (message.state.oneofKind === "unmanaged")
            AppManagedState_AppManagedStateUnmanaged.internalBinaryWrite(message.state.unmanaged, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedState.AppManagedStateManaged managed = 101; */
        if (message.state.oneofKind === "managed")
            AppManagedState_AppManagedStateManaged.internalBinaryWrite(message.state.managed, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState
 */
export const AppManagedState = new AppManagedState$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState_AppManagedStateUnmanaged$Type extends MessageType<AppManagedState_AppManagedStateUnmanaged> {
    constructor() {
        super("c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged", []);
    }
    create(value?: PartialMessage<AppManagedState_AppManagedStateUnmanaged>): AppManagedState_AppManagedStateUnmanaged {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppManagedState_AppManagedStateUnmanaged>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedState_AppManagedStateUnmanaged): AppManagedState_AppManagedStateUnmanaged {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedState_AppManagedStateUnmanaged, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState.AppManagedStateUnmanaged
 */
export const AppManagedState_AppManagedStateUnmanaged = new AppManagedState_AppManagedStateUnmanaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedState_AppManagedStateManaged$Type extends MessageType<AppManagedState_AppManagedStateManaged> {
    constructor() {
        super("c1.api.app.v1.AppManagedState.AppManagedStateManaged", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppManagedState_AppManagedStateManaged>): AppManagedState_AppManagedStateManaged {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        if (value !== undefined)
            reflectionMergePartial<AppManagedState_AppManagedStateManaged>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedState_AppManagedStateManaged): AppManagedState_AppManagedStateManaged {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedState_AppManagedStateManaged, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedState.AppManagedStateManaged
 */
export const AppManagedState_AppManagedStateManaged = new AppManagedState_AppManagedStateManaged$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingView$Type extends MessageType<AppManagedStateBindingView> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingView", [
            { no: 1, name: "app_management_state_binding", kind: "message", T: () => AppManagedStateBinding },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateBindingView>): AppManagedStateBindingView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appPath = "";
        message.resourcePath = "";
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateBindingView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateBindingView): AppManagedStateBindingView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppManagedStateBinding app_management_state_binding */ 1:
                    message.appManagementStateBinding = AppManagedStateBinding.internalBinaryRead(reader, reader.uint32(), options, message.appManagementStateBinding);
                    break;
                case /* string app_path */ 2:
                    message.appPath = reader.string();
                    break;
                case /* string resource_path */ 3:
                    message.resourcePath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateBindingView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppManagedStateBinding app_management_state_binding = 1; */
        if (message.appManagementStateBinding)
            AppManagedStateBinding.internalBinaryWrite(message.appManagementStateBinding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_path = 2; */
        if (message.appPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appPath);
        /* string resource_path = 3; */
        if (message.resourcePath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourcePath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingView
 */
export const AppManagedStateBindingView = new AppManagedStateBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingExpandMask$Type extends MessageType<AppManagedStateBindingExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateBindingExpandMask>): AppManagedStateBindingExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateBindingExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateBindingExpandMask): AppManagedStateBindingExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateBindingExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingExpandMask
 */
export const AppManagedStateBindingExpandMask = new AppManagedStateBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppManagedStateBindingRequest$Type extends MessageType<GetAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<GetAppManagedStateBindingRequest>): GetAppManagedStateBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppManagedStateBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppManagedStateBindingRequest): GetAppManagedStateBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 3:
                    message.resourceId = reader.string();
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask */ 4:
                    message.expandMask = AppManagedStateBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppManagedStateBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 3; */
        if (message.resourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceId);
        /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppManagedStateBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppManagedStateBindingRequest
 */
export const GetAppManagedStateBindingRequest = new GetAppManagedStateBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppManagedStateBindingResponse$Type extends MessageType<GetAppManagedStateBindingResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppManagedStateBindingResponse", [
            { no: 1, name: "app_management_state", kind: "message", T: () => AppManagedStateBindingView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<GetAppManagedStateBindingResponse>): GetAppManagedStateBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<GetAppManagedStateBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppManagedStateBindingResponse): GetAppManagedStateBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppManagedStateBindingView app_management_state */ 1:
                    message.appManagementState = AppManagedStateBindingView.internalBinaryRead(reader, reader.uint32(), options, message.appManagementState);
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppManagedStateBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppManagedStateBindingView app_management_state = 1; */
        if (message.appManagementState)
            AppManagedStateBindingView.internalBinaryWrite(message.appManagementState, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppManagedStateBindingResponse
 */
export const GetAppManagedStateBindingResponse = new GetAppManagedStateBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppManagedStateBindingsRequest$Type extends MessageType<SearchAppManagedStateBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppManagedStateBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "states", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { repeated: { unique: true, items: { int32: { gte: 100 } }, ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingRef },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
    create(value?: PartialMessage<SearchAppManagedStateBindingsRequest>): SearchAppManagedStateBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.states = [];
        message.refs = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppManagedStateBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppManagedStateBindingsRequest): SearchAppManagedStateBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* repeated int32 states */ 4:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.states.push(reader.int32());
                    else
                        message.states.push(reader.int32());
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask */ 5:
                    message.expandMask = AppManagedStateBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.app.v1.AppManagedStateBindingRef refs */ 6:
                    message.refs.push(AppManagedStateBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string app_ids */ 7:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppManagedStateBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* repeated int32 states = 4; */
        if (message.states.length) {
            writer.tag(4, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.states.length; i++)
                writer.int32(message.states[i]);
            writer.join();
        }
        /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppManagedStateBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppManagedStateBindingRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppManagedStateBindingRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 7; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppManagedStateBindingsRequest
 */
export const SearchAppManagedStateBindingsRequest = new SearchAppManagedStateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppManagedStateBindingsRequest$Type extends MessageType<ListAppManagedStateBindingsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppManagedStateBindingsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<ListAppManagedStateBindingsRequest>): ListAppManagedStateBindingsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.resourceTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppManagedStateBindingsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppManagedStateBindingsRequest): ListAppManagedStateBindingsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 4:
                    message.resourceTypeId = reader.string();
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask */ 5:
                    message.expandMask = AppManagedStateBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppManagedStateBindingsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 4; */
        if (message.resourceTypeId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.resourceTypeId);
        /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppManagedStateBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppManagedStateBindingsRequest
 */
export const ListAppManagedStateBindingsRequest = new ListAppManagedStateBindingsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppManagedStateBindingsResponse$Type extends MessageType<ListAppManagedStateBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppManagedStateBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ListAppManagedStateBindingsResponse>): ListAppManagedStateBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppManagedStateBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppManagedStateBindingsResponse): ListAppManagedStateBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppManagedStateBindingView list */ 1:
                    message.list.push(AppManagedStateBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppManagedStateBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppManagedStateBindingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppManagedStateBindingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppManagedStateBindingsResponse
 */
export const ListAppManagedStateBindingsResponse = new ListAppManagedStateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppManagedStateBindingsResponse$Type extends MessageType<SearchAppManagedStateBindingsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppManagedStateBindingsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchAppManagedStateBindingsResponse>): SearchAppManagedStateBindingsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchAppManagedStateBindingsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppManagedStateBindingsResponse): SearchAppManagedStateBindingsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppManagedStateBindingView list */ 1:
                    message.list.push(AppManagedStateBindingView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppManagedStateBindingsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppManagedStateBindingView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppManagedStateBindingView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppManagedStateBindingsResponse
 */
export const SearchAppManagedStateBindingsResponse = new SearchAppManagedStateBindingsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingRef$Type extends MessageType<AppManagedStateBindingRef> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateBindingRef>): AppManagedStateBindingRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateBindingRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateBindingRef): AppManagedStateBindingRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 3:
                    message.resourceId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateBindingRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 3; */
        if (message.resourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingRef
 */
export const AppManagedStateBindingRef = new AppManagedStateBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateBindingSearchFilter$Type extends MessageType<AppManagedStateBindingSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateBindingSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppManagedStateBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "300" } } } }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateBindingSearchFilter>): AppManagedStateBindingSearchFilter {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateBindingSearchFilter>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateBindingSearchFilter): AppManagedStateBindingSearchFilter {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppManagedStateBindingRef refs */ 1:
                    message.refs.push(AppManagedStateBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateBindingSearchFilter, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppManagedStateBindingRef refs = 1; */
        for (let i = 0; i < message.refs.length; i++)
            AppManagedStateBindingRef.internalBinaryWrite(message.refs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateBindingSearchFilter
 */
export const AppManagedStateBindingSearchFilter = new AppManagedStateBindingSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromoteAppManagedStateBindingRequest$Type extends MessageType<PromoteAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.PromoteAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, ignoreEmpty: true } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<PromoteAppManagedStateBindingRequest>): PromoteAppManagedStateBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial<PromoteAppManagedStateBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PromoteAppManagedStateBindingRequest): PromoteAppManagedStateBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 3:
                    message.resourceId = reader.string();
                    break;
                case /* repeated string user_ids */ 4:
                    message.userIds.push(reader.string());
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask */ 5:
                    message.expandMask = AppManagedStateBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PromoteAppManagedStateBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 3; */
        if (message.resourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceId);
        /* repeated string user_ids = 4; */
        for (let i = 0; i < message.userIds.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.userIds[i]);
        /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppManagedStateBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.PromoteAppManagedStateBindingRequest
 */
export const PromoteAppManagedStateBindingRequest = new PromoteAppManagedStateBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateSearchTermsRequest$Type extends MessageType<AppManagedStateSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppManagedStateBindingsRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType", AppManagedStateSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateSearchTermsRequest>): AppManagedStateSearchTermsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.term = 0;
        message.query = "";
        message.includeCount = false;
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateSearchTermsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateSearchTermsRequest): AppManagedStateSearchTermsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.SearchAppManagedStateBindingsRequest search */ 1:
                    message.search = SearchAppManagedStateBindingsRequest.internalBinaryRead(reader, reader.uint32(), options, message.search);
                    break;
                case /* c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType term */ 2:
                    message.term = reader.int32();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* bool include_count */ 4:
                    message.includeCount = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateSearchTermsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.SearchAppManagedStateBindingsRequest search = 1; */
        if (message.search)
            SearchAppManagedStateBindingsRequest.internalBinaryWrite(message.search, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedStateSearchTermsRequest.TermType term = 2; */
        if (message.term !== 0)
            writer.tag(2, WireType.Varint).int32(message.term);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* bool include_count = 4; */
        if (message.includeCount !== false)
            writer.tag(4, WireType.Varint).bool(message.includeCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateSearchTermsRequest
 */
export const AppManagedStateSearchTermsRequest = new AppManagedStateSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppManagedStateSearchTermsResponse$Type extends MessageType<AppManagedStateSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppManagedStateSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
    create(value?: PartialMessage<AppManagedStateSearchTermsResponse>): AppManagedStateSearchTermsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<AppManagedStateSearchTermsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppManagedStateSearchTermsResponse): AppManagedStateSearchTermsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.search.v1.Facets facets */ 1:
                    message.facets = Facets.internalBinaryRead(reader, reader.uint32(), options, message.facets);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppManagedStateSearchTermsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.search.v1.Facets facets = 1; */
        if (message.facets)
            Facets.internalBinaryWrite(message.facets, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppManagedStateSearchTermsResponse
 */
export const AppManagedStateSearchTermsResponse = new AppManagedStateSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class MutateAppManagedStateBindingRequest$Type extends MessageType<MutateAppManagedStateBindingRequest> {
    constructor() {
        super("c1.api.app.v1.MutateAppManagedStateBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 3, name: "resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minLen: "1", maxLen: "512" } } } },
            { no: 4, name: "state", kind: "message", T: () => AppManagedState },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppManagedStateBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<MutateAppManagedStateBindingRequest>): MutateAppManagedStateBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.resourceTypeId = "";
        message.resourceId = "";
        if (value !== undefined)
            reflectionMergePartial<MutateAppManagedStateBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: MutateAppManagedStateBindingRequest): MutateAppManagedStateBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string resource_type_id */ 2:
                    message.resourceTypeId = reader.string();
                    break;
                case /* string resource_id */ 3:
                    message.resourceId = reader.string();
                    break;
                case /* c1.api.app.v1.AppManagedState state */ 4:
                    message.state = AppManagedState.internalBinaryRead(reader, reader.uint32(), options, message.state);
                    break;
                case /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask */ 5:
                    message.expandMask = AppManagedStateBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: MutateAppManagedStateBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string resource_type_id = 2; */
        if (message.resourceTypeId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.resourceTypeId);
        /* string resource_id = 3; */
        if (message.resourceId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.resourceId);
        /* c1.api.app.v1.AppManagedState state = 4; */
        if (message.state)
            AppManagedState.internalBinaryWrite(message.state, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppManagedStateBindingExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppManagedStateBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.MutateAppManagedStateBindingRequest
 */
export const MutateAppManagedStateBindingRequest = new MutateAppManagedStateBindingRequest$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppManagedStateService
 */
export const AppManagedStateService = new ServiceType("c1.api.app.v1.AppManagedStateService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" } }, I: ListAppManagedStateBindingsRequest, O: ListAppManagedStateBindingsResponse },
    { name: "Promote", options: { "authz.method": { role: "OWNER" } }, I: PromoteAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse },
    { name: "MutateState", options: { "authz.method": { role: "EDITOR" } }, I: MutateAppManagedStateBindingRequest, O: GetAppManagedStateBindingResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppManagedStateSearchService
 */
export const AppManagedStateSearchService = new ServiceType("c1.api.app.v1.AppManagedStateSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppManagedStateBindingsRequest, O: SearchAppManagedStateBindingsResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppManagedStateSearchTermsRequest, O: AppManagedStateSearchTermsResponse }
]);
